export default __webpack_public_path__ + "static/media/wallpaper_bg2.b2d05c31.png";